// 04.30.2024 use on backend
export const goalDateFormat = 'MM.DD.YYYY';
